























import {
  DynamicDocument,
  DynamicDocumentData,
  DynamicDocumentGroup,
  InstallationModule,
  InstallationModuleData,
  MechanicInstallation,
} from '@/types';
import Vue, { PropType } from 'vue';

import ItemProgress from './ItemProgress.vue';

export default Vue.extend({
  components: {
    ItemProgress,
  },

  props: {
    document: {
      type: Array as PropType<DynamicDocumentGroup[]>,
      default: () => [],
    },

    data: {
      type: Array as PropType<DynamicDocumentData>,
      default: () => [],
    },

    moduleData: {
      type: Object as PropType<InstallationModuleData>,
    },

    module: {
      type: Object as PropType<InstallationModule>,
    },

    installation: {
      type: Object as PropType<MechanicInstallation>,
    },
  },

  computed: {
    size(): number {
      return this.document.length;
    },

    width(): number {
      return 100 / this.size;
    },
  },
});
